export default "__VITE_ASSET__K_kcI8qT__"